import React, { Component, useRef } from 'react';
import * as Common from './CommonJs';
import $ from 'jquery'
import { connect } from 'react-redux'
import { Typeahead } from 'react-bootstrap-typeahead';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { SearchPatient } from '../OfflineDb/IndexDbTranscSP'
import DropDown from './DropdownRendrer'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'


const mapStateToProps = (store) => {
  return store
}
const mapDispatchToProps = (dispatch) => {
  return {
    ShowAlert: (Settings) => { dispatch({ type: "UpdateAlert", payload: Settings }) },
    ShowLoader: (Isloading) => { dispatch({ type: "UpdateLoader", payload: Isloading }) },
  }
}
class PatientsAutoComplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      options: [],
      val: [],

      FilteredOptions: [],

      Genderlist: [{ id: 1, label: "Male" }, { id: 2, label: "Female" }, { id: 3, label: "Other" }],
      GenderId: 1,
    };
    this.myRef = React.createRef();
  }

  componentDidMount() {
    Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_Patients, { sortField: 'id', sortOrder: 'ase'}, resp => {
      this.setState({ options: resp.data })
    })
  }

  handleSearch = (val) => {
    const TempPatients = this.state.options
    const filtered = TempPatients.filter(item => item.name === val.toString())
    this.setState({ FilteredOptions: filtered })
  }

  HandlePatientChange = (val) => {
    if (val[0]?.customOption) {
      this.ResetForm()
      $("#clearSelectedPatient_btn").click()
      $("#NewPatientModal_name").val(val[0]?.name)
      $("#AddNewPatientModal_btn").click()
      return
    }
    this.setState({
      val: val,
    })
    this.props.HandlePatientChange(val)
  }

  HandleAutoSuggestValChange = (fieldId, value) => {
    this.setState({ [fieldId]: value })
  }

  render() {
    return (
      <div>

        {/* -------------------New Patient-------- */}
        <button id="AddNewPatientModal_btn" style={{ display: "none" }} type="button" class="btn btn-primary" data-toggle="modal" data-target="#AddNewPatient_Modal">Large modal</button>
        <div class="modal fade" id="AddNewPatient_Modal" tabindex="-1" role="dialog" aria-labelledby="addappTitle" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: "500px" }}>
            <div class="modal-content">

              <div class="modal-header">
                <div class="ModalTopClose_btn"><span style={{ cursor: "pointer" }} id="AddNewPatientModal_Closebtn" data-dismiss="modal" aria-hidden="true">x</span></div>
                <div><h5 class="modal-title" style={{ fontSize: "17px", fontWeight: "700" }}>New Patient</h5></div>
                {/* <i class="fa fa-times-circle appointmentdetailcross" id="AddNewPatientModal_Closebtn" data-dismiss="modal" aria-hidden="true"></i> */}
              </div>

              <div class="modal-body">
                <form>

                  <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for=""><span style={{ color: "red" }}>* </span>Name</label>
                    <input autocomplete="off" type="text" class="form-control" id="NewPatientModal_name" placeholder="Enter patient name" />
                  </div>

                  <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for=""><span style={{ color: "red" }}>* </span>Phone</label>
                    <input autocomplete="off" pattern="[0][0-9]{10}" type="text" class="form-control" id="NewPatientModal_contact" placeholder="Enter patient phone - 03123456789" />
                  </div>

                  <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for=""><span style={{ color: "red" }}>* </span>Age</label>
                    <input class="form-control" id="NewPatientModal_Age" type="text" placeholder="Enter patient age" />
                  </div>

                  <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for=""><span style={{ color: "red" }}>* </span>Gender</label>
                    <DropDown
                      multi={false}
                      dropdownRenderer={false}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="GenderId"
                      options={this.state.Genderlist}
                      val={this.state.GenderId}
                      addPlaceholder=""
                      disabled={false}
                      loading={false}
                      searchBy="label"
                      labelField="label"
                      valueField="id"
                      contentRenderer={false}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="">CNIC/B-Form #</label>
                    <input class="form-control" id="NewPatientModal_CNIC" type="text" placeholder="Enter patient CNIC/B-Form #" />
                  </div>

                  <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label for="">Address</label>
                    <textarea class="form-control" id="NewPatientModal_address" placeholder="Enter patient address" rows="3"></textarea>
                  </div>

                  <div style={{ float: "right", marginRight: "15px", marginTop: "35px" }}>
                    <button type="button" class="btn btn_style3" data-dismiss="modal" aria-hidden="true">CANCEL</button>
                    <button type="button" onClick={this.SaveNewPatient} class="btn btn_style1">SAVE</button>
                  </div>

                </form>
              </div>

            </div>
          </div>
        </div>


        <div id="CustomerAutocomplete_Container" style={{ position: "relative" }}>
          <AsyncTypeahead
            allowNew
            newSelectionPrefix="Add New: "
            ref={this.myRef}
            onChange={this.HandlePatientChange}
            selected={this.props.selected}
            // defaultInputValue={this.props.defaultValue}
            // delay={500}
            id="Patients_Autocomplete"
            isLoading={this.props.isLoading}
            labelKey="name"
            minLength={1}
            onSearch={this.handleSearch}
            filterBy={['name', 'contact']}
            options={this.state.options}
            placeholder="Search by Name or phone number"
            renderMenuItemChildren={(option, props) => (
              <div class="auto_complete_ListItm">
                <div class="auto_complete_name">
                  {option.name}
                </div>
                <span hidden={Common.isEmptyUndef(option.contact)} class="auto_complete_price" style={{ float: "right" }}>
                  Contact: {" " + option.contact}
                </span>

              </div>
            )}

          />
          <button type="button" id={!(this.props.ClearBtId) ? "clearSelectedPatient_btn" : this.props.ClearBtId}
            style={{ display: "none" }}
            onClick={() => this.myRef.current.clear()}>
            Clear
          </button>



        </div>

      </div>
    );
  }
  ResetForm = () => {
    $("#NewPatientModal_name").val("")
    $("#NewPatientModal_contact").val("")
    $("#NewPatientModal_Age").val("")
    $("#NewPatientModal_CNIC").val("")
    $("#NewPatientModal_address").val("")
    this.setState({
      GenderId: 1
    })
  }
  SaveNewPatient = () => {

    if ($("#NewPatientModal_name").val() == "" || $("#NewPatientModal_name").val() == null) {
      this.props.ShowAlert({ Type: 0, Msg: "Please enter patient name" })
      setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
      return
    }
    if ($("#NewPatientModal_contact").val() == "" || $("#NewPatientModal_contact").val() == null) {
      this.props.ShowAlert({ Type: 0, Msg: "Please enter patient phone" })
      setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
      return
    }
    if ($("#NewPatientModal_Age").val() == "" || $("#NewPatientModal_Age").val() == null) {
      this.props.ShowAlert({ Type: 0, Msg: "Please enter patient age" })
      setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
      return
    }
    if (this.state.GenderId == 0) {
      this.props.ShowAlert({ Type: 0, Msg: "Please select patient gender" })
      setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
      return
    }

    this.props.ShowLoader({ Isloading: true })
    var Parameters = {
      id: 0,
      name: $("#NewPatientModal_name").val(),
      contact: $("#NewPatientModal_contact").val(),
      email: null,
      // dob:null,
      age: $("#NewPatientModal_Age").val(),
      address: $("#NewPatientModal_address").val(),
      gender: this.state.GenderId,
      cnic: $("#NewPatientModal_CNIC").val(),
    }
    Common.Ajax(this.props.UserAuthentication.AuthToken, "Post", false, Common.APILinks.Save_Patient, JSON.stringify(Parameters), (resp) => {
      if (resp.status) {
        SyncConfig(() => {
          this.ResetForm()
          $("#AddNewPatientModal_Closebtn").click()
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" })
          setTimeout(() => { $("#Alertmsgbtn").click() }, 50);
        },
          () => {
            this.ResetForm()
            $("#AddNewPatientModal_Closebtn").click()
            this.props.ShowLoader({ Isloading: false })
            this.props.ShowAlert({ Type: 0, Msg: "Error in sync, please reload the page" })
            setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
          })
      }
      else {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({ Type: 0, Msg: resp.message })
        setTimeout(() => { $("#Alertmsgbtn").click() }, 50);
      }
    },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({ Type: 0, Msg: "Something went wronge, please try again." })
        setTimeout(() => { $("#Alertmsgbtn").click() }, 50);
      })
  }


}
export default connect(mapStateToProps, mapDispatchToProps)(PatientsAutoComplete); 
